import React from 'react';
import ComparisonCard from './comparison-card';
import CurrentCard from './current-card';
import { CM2Dataset } from '@interfaces/central-monitoring';

interface IProps {
    studyRef: string;
    canEdit: boolean;
    siteId?: number;
    dataset?: CM2Dataset;
    comparisonDataset?: CM2Dataset;
}

const ReviewCards = ({ studyRef, canEdit, siteId, dataset, comparisonDataset }: IProps) => {
    return (
        <>
            <ComparisonCard studyRef={studyRef} siteId={siteId} comparisonDataset={comparisonDataset} />

            <CurrentCard studyRef={studyRef} siteId={siteId} dataset={dataset} canEdit={canEdit} />
        </>
    );
};

export default ReviewCards;
